"use client";

import { createContext, ReactNode, useContext, useEffect, useState } from "react";

interface FasterUrlUpdateContextType {
    /** the url that will get load (or loaded) - will change when user clicks a {NavigationMenuLink} with {fasterUrlUpdate} prop */
    fastUrl: string;
    /** triggers the url change (used on links logic) */
    setFastUrl: (url: string) => void;
}

const FasterUrlUpdateContext = createContext<FasterUrlUpdateContextType>({
    fastUrl: "",
    setFastUrl: () => { },
});

/** provider for {FasterUrlUpdateContext} */
export function FasterUrlUpdateProvider({ children }: { children: ReactNode }) {
    const [fastUrl, setFastUrl] = useState("");

    //set default url value to current page
    useEffect(() => {
        setFastUrl(window.location.pathname)
    }, [])

    return (
        <FasterUrlUpdateContext.Provider value={ { fastUrl, setFastUrl } }>
            { children }
        </FasterUrlUpdateContext.Provider>
    );
};

/** usage for fast url update / trigger */
export function useFasterUrlUpdate() {
    return useContext(FasterUrlUpdateContext)
};
